import { render, staticRenderFns } from "./FaqAdd.vue?vue&type=template&id=038d828a"
import script from "./FaqAdd.vue?vue&type=script&lang=js"
export * from "./FaqAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports